<template>
  <div
    class="search-box"
    @click="handleSearchBoxClick"
    :style="{
      'background-color': isAlpha
        ? 'rgba(255.0, 255.0, 255.0, 0.1)'
        : '#f7f8fa',
    }"
  >
    <p class="city_text" @click="selectCity">
      {{ currentSelectCity.length > 0 ? currentSelectCity : city }}
    </p>
    <img class="downIcon" src="@/assets/home/downIcon.png" alt="" />
    <div v-if="isShowDate" class="date_box" @click="calendarShow = true">
      <div class="live_box"><span>住</span>{{ startDate }}</div>
      <div class="leave_box"><span>离</span>{{ endDate }}</div>
    </div>
    <p class="middleLine"></p>
    <img class="search_icon" src="../../../assets/home/searchIcon.png" />
    <div class="input_box">
      <input
        class="input_text_box"
        v-model="inputValue"
        @input="changeValue"
        type="text"
        v-bind:placeholder="placeHoder"
        @blur="searchEvent"
        @keyup.enter="searchEvent"
      />
      <div
        v-if="isShowInputMask"
        @click="clickSearchBox"
        class="mask_box"
      ></div>
    </div>

    <van-popup
      position="bottom"
      round
      :close-on-click-overlay="false"
      v-model="isShowCitySelect"
    >
      <div class="current-location-box" @click="setCurrentLocation">
        <img style="width:9px;" src="@/assets/home/location_img.png" alt="" />
        <span style="padding-left: 5px"
          >当前定位:{{ position.name || "" }}</span
        >
      </div>
      <van-area
        title="城市选择"
        :area-list="areaList"
        :value="currentSelectCode"
        :columns-num="2"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
    <van-calendar v-model="calendarShow" type="range" @confirm="onConfirm" :default-date="defaultDate" />
  </div>
</template>

<script>
import { parseTime, getTimeIn } from "@/utils";
import area from "@/lib/area.js";
export default {
  name: "search",
  props: {
    city: {
      type: String,
      default() {
        return "全国";
      },
    },
    code: {
      type: String,
      default() {
        return "";
      },
    },
    isShowDate: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isShowInputMask: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isAlpha: {
      type: Boolean,
      default() {
        return false;
      },
    },
    placeHoder: {
      type: String,
      default() {
        return "请输入您想要搜索的内容";
      },
    },
    liveDate: undefined,
    leaveDate: undefined,
    searchKey: "",
  },
  data() {
    return {
      //   liveDate: parseTime(new Date(), "{mm}-{dd}"), //入住时间
      //   leaveDate: parseTime(getTimeIn(new Date(), 1), "{mm}-{dd}"), //离开时间
      calendarShow: false,
      inputValue: "", //输入框的值
      isShowCitySelect: false,
      areaList: area,
      currentSelectCity: "",
      currentSelectCode: "", //当前选中城市的code
      position: {},
    };
  },
  created() {
    // 删除全国
    var tempObj = { ...area }
    if (tempObj) {
      if (tempObj.city_list[100100]) {
        delete tempObj.city_list[100100]
      }
      if (tempObj.county_list[100101]) {
        delete tempObj.county_list[100101]
      }
      if (tempObj.province_list[100000]) {
        delete tempObj.province_list[100000]
      }
    }
    this.areaList = tempObj
  },
  mounted() {
    this.position = this.$store.state.position || {};
    if (this.searchKey) {
      this.inputValue = this.searchKey;
    } else {
      this.inputValue = ''
    }
  },
  watch: {
    code: function(val) {
      this.currentSelectCode = val;
    },
    searchKey: function(val) {
      this.inputValue = val;
    },
  },
  computed: {
    startDate() {
      if (this.liveDate) {
        return parseTime(this.liveDate, "{mm}-{dd}");
      }
      return "";
    },
    endDate() {
      if (this.leaveDate) {
        return parseTime(this.leaveDate, "{mm}-{dd}");
      }
      return "";
    },
    defaultDate() {
      if (this.liveDate && this.leaveDate) {
        return [new Date (new Date(this.liveDate).getTime()), new Date (new Date(this.leaveDate).getTime())];
      }

      return null;
    },
  },
  methods: {
    clickSearchBox() {
      this.$router.push({ path: "/home/searchContentList/index" });
      //   this.$router.push({ path: "/home/searchContentList/index" });
    },
    onConfirm(values) {
      const [start, end] = values;
      this.$emit("selectDate", start, end);
      this.calendarShow = false;
    },
    selectCity() {
      // this.$emit("selectCity");
      // this.$router.push({ path: "/chooseCity" });
      this.isShowCitySelect = true;
    },
    changeValue() {
      // console.log('获取角度' ,this.inputValue);
    },

    setCurrentLocation() {
      if (this.position.code) {
        this.confirm([{}, this.position]);
      }
    },

    confirm(item) {
      this.currentSelectCity = item[1].name;
      this.currentSelectCode = item[1].code;
      this.$emit("placeCity", item[1].name == "全国" ? "" : item[1].code);
      var cityTemp = [
        { name: item[0].name, code: item[0].code },
        {
          name: item[1].name,
          code: item[1].code,
        },
      ];
      // 将地址信息设置到缓存中
      sessionStorage.setItem("city", JSON.stringify(cityTemp));
      this.cancel();
    },
    cancel() {
      this.isShowCitySelect = false;
    },
    searchEvent(e) {
      this.$emit("inputChange", this.inputValue);
    },
    handleSearchBoxClick(){
      this.$emit("handleSearchBoxClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #f7f8fa;

  .city_text {
    margin-left: vw(30);
    max-width: vw(200);
    color: #333333;
    font-size: vw(26);
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .downIcon {
    margin-left: vw(11);
    width: vw(14);
    height: vw(8);
  }
  .date_box {
    margin-left: vw(26);
    width: vw(120);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #3377ff;
    font-size: vw(20);
    span {
      color: #c2c5cc;
      margin-right: vw(10);
    }
  }

  .middleLine {
    margin-left: vw(24);
    background-color: #d8d8d8;
    width: vw(2);
    height: vw(44);
  }

  .search_icon {
    margin-left: vw(20);
    width: vw(32);
    height: vw(32);
  }

  .input_box {
    margin-left: vw(12);
    margin-right: vw(20);
    flex: 1;
    height: 100%;
    position: relative;
    .input_text_box {
      width: 100%;
      height: 100%;
      color: #333333;
      font-size: vw(26);
      background-color: rgba(255, 255, 255, 0);
      border: 0;
    }
    .mask_box {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      //   background-color: red;
    }
  }

  .current-location-box {
    position: absolute;
    left: 15px;
    top: 44px;
    z-index: 100;
    height: 30px;
    display: flex;
    align-items: center;
    color: #999;
    font-size: 14px;
  }
  ::v-deep .van-picker__toolbar {
    padding-bottom: 50px;
  }
}
</style>
